<template>
  <div v-bind:class="getClass()" @click="propagateClick">
    <div class="pthvSchedule-line">
      <span class="pthvSchedule-modeLine">
        <span :class="lineModeStyle"></span>
        <span class="pthvSchedule-numLine" :style="lineColorStyle">
          {{ destination.mnemoService }}
        </span>
      </span>

      <span class="pthvSchedule-nameDestLine">
        {{ destination.firstTime.nameDest }}
      </span>
    </div>

    <div class="pthvSchedule-nextDeparture">
      <span class="pthvSchedule-times" v-if="destination.times.length">
        <ApthScheduleTime v-for="(tdata, index) in destination.times" :key="index"
          :timeData="tdata"
          :indicators="indicators"
          :showOccupancy="showOccupancy"
          :showDeparture="showDeparture"
          :showTerminus="showTerminus"
          :alwaysShowHours="alwaysShowHours"
        />
      </span>
      <span v-else>
        <em>{{ $t('endofservice') }}</em>
      </span>
    </div>

    <span v-if="hasDisruption" class="pthvSchedule-perturbsLine">
      <span v-if="destination.serviceDisruption" class="tooltip" title="perturbation sur la ligne">
        <span class="perturb ligne">⚑</span>
        <span class="element-invisible">perturbation sur la ligne</span>
      </span>
      <span v-if="destination.globalDisruption" class="tooltip" title="perturbation générale">
        <span class="perturb general">▲</span>
        <span class="element-invisible">perturbation générale</span>
      </span>
      <span v-if="destination.busStopDisruption" class="tooltip" title="perturbation sur l'arrêt">
        <span class="perturb arret">●</span>
        <span class="element-invisible">perturbation sur l'arrêt</span>
      </span>
    </span>
  </div>
</template>

<script>
import ApthScheduleTime from "./ApthScheduleTime";
export default {
  name: "ApthScheduleStopDestination",
  data() {
    return {};
  },
  components: {
    ApthScheduleTime
  },
  computed: {
    lineModeStyle() {
      const lineModeStyles = {
        BUS: "iconMode modeBus",
        TRAM: "iconMode modeTram",
        RAIL: "iconMode modeRail",
        SUBWAY: "iconMode modeSubway",
        FERRY: "iconMode modeFerry",
        CABLECAR: "iconMode modeCablecar",
        GONDOLA: "iconMode modeGondola",
        FUNICULAR: "iconMode modeFunicular"
      };
      return lineModeStyles[this.destination.line.mode];
    },
    lineColorStyle() {
      if (this.destination && this.destination.line && this.destination.line.colors) {
        var txtColor = this.destination.line.colors.color;
        var bgColor = this.destination.line.colors.bgcolor;
        if (txtColor && bgColor) {
          return "background-color:" + bgColor + ";color:" + txtColor + ";";
        }
      }
      return "";
    },
    hasDisruption() {
      return (this.destination.serviceDisruption || this.destination.globalDisruption || this.destination.busStopDisruption);
    },
  },
  props: {
    destination: {
      type: Object,
      required: true
    },
    showOccupancy: {
      type: Boolean,
      required: false,
      default: true,
    },
    showDeparture: {
      type: Boolean,
      required: false,
      default: true,
    },
    showTerminus: {
      type: Boolean,
      required: false,
      default: true,
    },
    alwaysShowHours: {
      type: Boolean,
      required: false,
      default: false,
    },
    indicators: {
      type: Object,
      required: false,
      default: () => {
        return {
          'any': true,
        };
      },
    },
  },
  methods: {
    getClass() {
      return {
        'pthvSchedule-row': true,
        'pthvSchedule-row-active': this.destination.times.length
      }
    },
    propagateClick() {
      this.$emit("click");
    }
  }
};
</script>

<style lang="scss">
// variable
@import "../styles/utilities/_variables.scss";

.pthvSchedule-row {
  display: flex;
  align-items: center;
  padding: 0.25rem;
  border: 1px solid #eee;
  margin-bottom: -1px;
  font-family: $apth_fontFamily;

  &:hover,
  &:focus {
    background-color: rgba($apth_color-black, 0.05);
  }
}

.pthvSchedule-row-active {
  cursor: pointer;
}

.pthvSchedule-line {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  span {
    display: inline-block;
  }
}

.pthvSchedule-numLine {
  padding: 0.25rem;
  min-width: 1.5rem;
  margin-right: 0.25rem;
  text-align: center;
  border-radius: 3px;
}

.pthvSchedule-nextDeparture {
  margin-left: auto;
}

.pthvSchedule-times {
  display: flex;
  column-gap: 1rem;
}
</style>
